import React from 'react';
import cn from 'classnames';
import styles from './CardHeader.module.scss';

const CardHeader = ({ action, className, title, titleProps, ...props }) => {
  return (
    <div className={cn(styles.root, className)} {...props}>
      {title && (
        <div {...titleProps} className={cn(styles.title, titleProps?.className)}>
          {title}
        </div>
      )}
      {action && action}
    </div>
  );
};

export default CardHeader;
